import React, { useEffect, useState } from "react";
import "../../css/CRUDModal.css";
import ButtonTriangle from "../../assets/Icons/bthTriangle.svg";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { ReactComponent as ChevronUp } from "../../assets/Icons/ChevronUp.svg";
import { ReactComponent as ChevronDownIcon } from "../../assets/Icons/Chevron down.svg";
import { useForm, Controller } from "react-hook-form";
import { Box, CircularProgress } from "@mui/material";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosGetApi, axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";

const statusOptions = [
  { value: "1", label: "Active" },
  { value: "4", label: "In-Active" },
  { value: "3", label: "Block" },
  { value: "5", label: "Rejected" },
];

const statusOptionsTwo = [
  { value: "1", label: "Active" },
  { value: "4", label: "In-Active" },
];

const CustFilterModal = ({
  show,
  handleClose,
  walletTitle,
  auditData,
  setCustomerData,
  setPageDetails,
  setNoData,
  pageSize,
  currentPage,
  filterData,
  setFilterData,
  handleReset,
  text,
}) => {
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    formState: { isSubmitting, errors },
  } = useForm({
    defaultValues: filterData,
    mode: "onChange",
  });

  const loggedInUserName = sessionStorage.getItem("username");
  const userRole = sessionStorage.getItem("userRole");
  const isCust = userRole === "CUST";
  const dynamicStatus = text === "AddUser" ? statusOptionsTwo : statusOptions;

  const [selectedTab, setSelectedTab] = useState(
    isCust ? "Company Id" : "Company Name"
  );
  const [loading, setLoading] = useState(false);
  const [customerNameOpen, setCustomerNameOpen] = useState(false);
  const [customerList, setCustomerList] = useState([]);
  const [vendorList, setVendorList] = useState([]);

  const handleTabChange = (e, tabName) => {
    e.preventDefault();
    setSelectedTab(tabName);
  };

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const onSubmit = (data) => {
    // setFilterData(data);
    fetchCustomerData(currentPage);
  };

  const fetchVendorData = () => {
    const payload = {
      username: loggedInUserName,
      vendorId: "",
      vendorName: "",
      smsType: "",
      fromDate: "",
      toDate: "",
      status: ["Active"],
    };

    axiosPostApi(
      `${apiList.FETCH_VENDOR_DATA}?&pageSize=${10}&pageNo=${1}`,
      payload
    )
      .then((response) => {
        if (
          response?.data?.status === true &&
          response?.data?.respCode === "00"
        ) {
          const vendorData = response?.data?.data;
          setVendorList(vendorData ?? []);
        } else {
          setVendorList([]);
        }
      })
      .catch((error) => {
        CustomAlert({
          title: "Error",
          text: "An error occurred while fetching the data. Please try again later.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      });
  };

  useEffect(() => {
    if (!isCust) {
      fetchVendorData();
    }
  }, []);

  const fetchCustomerData = async (currentPage) => {
    setLoading(true);
    try {
      const requestBody = {
        username: loggedInUserName,
        ...filterData,
        status: filterData.status || [],
        fromDate: formatDate(filterData.fromDate),
        toDate: formatDate(filterData.toDate),
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_CUSTOMER_DATA}?&pageSize=${pageSize}&pageNo=${1}`,
        requestBody
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);
        const modifiedData = modifyStructure(response?.data?.data);
        setCustomerData(modifiedData);
        setNoData(modifiedData?.length === 0);
        handleClose();
      } else {
        CustomAlert({
          title: "Failed",
          text:
            response?.data?.message ||
            "There was an issue processing the request.",
          icon: "error",
          confirmButtonText: "Retry",
        });

        setCustomerData([]);
        setNoData(true);
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const modifyStructure = (response) => {
    return (
      response &&
      response?.map((customer, index) => ({
        ...customer,
        id: index + 1,
        address:
          customer.address1 +
          ", " +
          customer.address2 +
          ", " +
          customer.address3,
      }))
    );
  };

  const onReset = () => {
    reset({
      customerCode: "",
      gstNumber: "",
      status: [],
      fromDate: "",
      toDate: "",
      companyPanNumber: "",
      firstContactPersonMobileNo: "",
      assignedVendorCode: "",
    });
    setFilterData({
      customerCode: "",
      gstNumber: "",
      status: [],
      fromDate: "",
      toDate: "",
      companyPanNumber: "",
      firstContactPersonMobileNo: "",
      assignedVendorCode: "",
    });
    handleReset();
  };

  const toggleCustomerNameDropdown = () =>
    setCustomerNameOpen(!customerNameOpen);

  useEffect(() => {
    fetchActiveCustomerData();
  }, []);

  const fetchActiveCustomerData = async () => {
    try {
      const response = await axiosGetApi(apiList.ALL_ACTIVE_CUSTOMER_DATA);

      if (response?.status === 200) {
        setCustomerList(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching customer data:", error);
    }
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "40vw",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                  justifyContent: "space-between",
                }}
              >
                <h5 className="modal-title main-title">Filter</h5>
                <HighlightOffIcon
                  onClick={handleClose}
                  style={{ cursor: "pointer" }}
                />
              </div>
              <Box component="form">
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <div className="tab-container">
                    <ul className="tab-list">
                      {[
                        isCust ? "Company Id" : "Company Name",
                        "GST No.",
                        "Status",
                        "Created Date",
                        "Company PAN No",
                        "Mobile No",
                        ...(isCust ? [] : ["Assigned Vendor"]),
                      ].map((tab) => (
                        <div className="tab-wrapper" key={tab}>
                          <li
                            className={
                              selectedTab === tab
                                ? "tab-item selected"
                                : "tab-item"
                            }
                          >
                            <button
                              className={`tab-button ${
                                selectedTab === tab ? "active" : ""
                              }`}
                              onClick={(e) => handleTabChange(e, tab)}
                            >
                              {tab}
                            </button>
                          </li>
                          {selectedTab === tab && (
                            <img
                              src={ButtonTriangle}
                              alt="tri"
                              className="tab-triangle"
                            />
                          )}
                        </div>
                      ))}
                    </ul>

                    <div className="tab-content">
                      {selectedTab === "Company Id" && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <label className="dateLabel">Company ID</label>
                            <input
                              type="text"
                              placeholder="Enter Company ID"
                              className="dateInput"
                              value={filterData.customerCode}
                              maxLength={20}
                              pattern="[A-Za-z0-9]+"
                              onChange={(e) => {
                                const val = e.target.value;
                                const cleanedVal = val.replace(
                                  /[^a-zA-Z0-9]/g,
                                  ""
                                );
                                setFilterData((prev) => ({
                                  ...prev,
                                  customerCode: cleanedVal,
                                }));
                              }}
                            />
                          </div>
                        </div>
                      )}

                      {selectedTab === "Company Name" && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <label className="dateLabel">Company Name</label>
                            <div className="form-group position-relative">
                              <select
                                className="form-control select-dropdown"
                                id="name"
                                placeholder="Role"
                                onClick={toggleCustomerNameDropdown}
                                value={filterData.companyId || ""}
                                onChange={(e) => {
                                  const selectedCode = e.target.value;
                                  const selectedCustomer = customerList.find(
                                    (customer) =>
                                      customer.customerCode === selectedCode
                                  );

                                  // Save customerCode for backend
                                  setFilterData((prev) => ({
                                    ...prev,
                                    companyId:
                                      selectedCustomer?.customerCode || "",
                                    name: selectedCustomer?.name || "",
                                  }));

                                  // Optional: if using react-hook-form
                                  setValue(
                                    "companyId",
                                    selectedCustomer?.customerCode || ""
                                  );
                                  setValue(
                                    "name",
                                    selectedCustomer?.name || ""
                                  );
                                }}
                              >
                                <option value="" disabled selected>
                                  Select Company Name
                                </option>
                                {customerList?.map((customer) => {
                                  return (
                                    <option
                                      key={customer.customerCode}
                                      value={customer.customerCode}
                                    >
                                      {customer.name}
                                    </option>
                                  );
                                })}
                              </select>
                              <span className="position-absolute select-icon">
                                {customerNameOpen ? (
                                  <ChevronUp />
                                ) : (
                                  <ChevronDownIcon />
                                )}
                              </span>
                            </div>
                            {errors.customerName ? (
                              <span className="error">
                                {errors.customerName}
                              </span>
                            ) : null}
                          </div>
                        </div>
                      )}

                      {selectedTab === "GST No." && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <Controller
                              name="gstNumber"
                              control={control}
                              rules={{
                                pattern: {
                                  value:
                                    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                                  message: "Invalid GST Number format",
                                },
                              }}
                              render={({ field }) => (
                                <>
                                  <label className="dateLabel">GST No.</label>
                                  <input
                                    {...field}
                                    type="text"
                                    placeholder="Enter GST No."
                                    className="dateInput"
                                    value={filterData.gstNumber}
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      setFilterData((prev) => ({
                                        ...prev,
                                        gstNumber: val,
                                      }));
                                      field.onChange(val);
                                    }}
                                  />
                                  {errors.gstNumber && (
                                    <span className="error-text">
                                      {errors.gstNumber.message}
                                    </span>
                                  )}
                                </>
                              )}
                            />
                          </div>
                        </div>
                      )}

                      {selectedTab === "Status" && (
                        <div className="dateField">
                          <label
                            className="dateLabel"
                            style={{
                              marginBottom: "0.5rem",
                              fontWeight: "600",
                              fontSize: "25px",
                            }}
                          >
                            Status
                          </label>
                          <div
                            className="dateInputWrapper"
                            style={{
                              display: "flex",
                              gap: "1rem",
                              flexWrap: "wrap",
                              padding: "0.75rem",
                              backgroundColor: "#f8f9fa",
                              border: "1px solid #ced4da",
                              borderRadius: "0.5rem",
                            }}
                          >
                            {dynamicStatus.map((status) => (
                              <label
                                key={status.value}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.5rem",
                                  padding: "0.5rem 0.75rem",
                                  borderRadius: "0.375rem",
                                  cursor: "pointer",
                                  fontSize: "0.9rem",
                                  fontWeight: "500",
                                  boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={(filterData.status || []).includes(
                                    status.label
                                  )}
                                  onChange={(e) => {
                                    const isChecked = e.target.checked;
                                    const newStatus = isChecked
                                      ? [
                                          ...(filterData.status || []),
                                          status.label,
                                        ]
                                      : (filterData.status || []).filter(
                                          (v) => v !== status.label
                                        );
                                    setValue("status", newStatus);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      status: newStatus,
                                    }));
                                  }}
                                  style={{ cursor: "pointer" }}
                                />
                                {status.label}
                              </label>
                            ))}
                          </div>
                        </div>
                      )}

                      {selectedTab === "Created Date" && (
                        <div
                          className="dateGrid"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "1rem",
                            alignItems: "flex-start",
                          }}
                        >
                          <Controller
                            name="fromDate"
                            control={control}
                            rules={{
                              validate: {
                                validDate: (value) =>
                                  !value ||
                                  !isNaN(Date.parse(value)) ||
                                  "Invalid From Date",
                                notFuture: (value) =>
                                  !value ||
                                  new Date(value) <= new Date() ||
                                  "From Date cannot be in the future",
                                beforeToDate: (value, formValues) =>
                                  !value ||
                                  !formValues.toDate ||
                                  new Date(value) <=
                                    new Date(formValues.toDate) ||
                                  "From Date must be before To Date",
                                requiredIfToDate: (value, formValues) =>
                                  !formValues.toDate ||
                                  !!value ||
                                  "From Date is required when To Date is selected",
                              },
                            }}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <label className="dateLabel">From Date</label>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        fromDate: e.target.value,
                                      }));
                                    }}
                                  />
                                  {errors.fromDate && (
                                    <span className="error-text">
                                      {errors.fromDate.message}
                                    </span>
                                  )}
                                </div>
                              </div>
                            )}
                          />
                          <Controller
                            name="toDate"
                            control={control}
                            rules={{
                              validate: {
                                validDate: (value) =>
                                  !value ||
                                  !isNaN(Date.parse(value)) ||
                                  "Invalid To Date",
                                notFuture: (value) =>
                                  !value ||
                                  new Date(value) <= new Date() ||
                                  "To Date cannot be in the future",
                                afterFromDate: (value, formValues) =>
                                  !value ||
                                  !formValues.fromDate ||
                                  new Date(value) >=
                                    new Date(formValues.fromDate) ||
                                  "To Date must be after From Date",
                                requiredIfFromDate: (value, formValues) =>
                                  !formValues.fromDate ||
                                  !!value ||
                                  "To Date is required when From Date is selected",
                              },
                            }}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <label className="dateLabel">To Date</label>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        toDate: e.target.value,
                                      }));
                                    }}
                                  />
                                  {errors.toDate && (
                                    <span className="error-text">
                                      {errors.toDate.message}
                                    </span>
                                  )}
                                </div>
                              </div>
                            )}
                          />
                        </div>
                      )}

                      {selectedTab === "Company PAN No" && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <Controller
                              name="companyPanNumber"
                              control={control}
                              rules={{
                                pattern: {
                                  value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                                  message:
                                    "Invalid PAN Number format. (e.g., ABCDE1234F)",
                                },
                              }}
                              render={({ field }) => (
                                <>
                                  <label className="dateLabel">
                                    Company PAN No
                                  </label>
                                  <input
                                    {...field}
                                    type="text"
                                    placeholder="Enter Company PAN No"
                                    className="dateInput"
                                    value={filterData.companyPanNumber}
                                    onChange={(e) => {
                                      const val = e.target.value
                                        .toUpperCase()
                                        .replace(/[^A-Z0-9]/g, "");
                                      setFilterData((prev) => ({
                                        ...prev,
                                        companyPanNumber: val,
                                      }));
                                      field.onChange(val);
                                    }}
                                    maxLength={10}
                                  />
                                  {errors.companyPanNumber && (
                                    <span className="error-text">
                                      {errors.companyPanNumber.message}
                                    </span>
                                  )}
                                </>
                              )}
                            />
                          </div>
                        </div>
                      )}

                      {selectedTab === "Mobile No" && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <Controller
                              name="firstContactPersonMobileNo"
                              control={control}
                              rules={{
                                minLength: {
                                  value: 10,
                                  message:
                                    "Mobile No must be at least 10 characters",
                                },
                                pattern: {
                                  value: /^[6-9]\d{9}$/,
                                  message:
                                    "Please enter a valid 10-digit mobile number starting with 6, 7, 8, or 9",
                                },
                                validate: {
                                  noRepeats: (value) =>
                                    !/^([0-9])\1*$/.test(value) ||
                                    "Repeated characters are not allowed",
                                },
                              }}
                              render={({ field }) => (
                                <>
                                  <label className="dateLabel">Mobile No</label>
                                  <input
                                    {...field}
                                    type="text"
                                    placeholder="Enter Mobile No"
                                    className="dateInput"
                                    value={
                                      filterData.firstContactPersonMobileNo
                                    }
                                    onChange={(e) => {
                                      const val = e.target.value.replace(
                                        /[^0-9]/g,
                                        ""
                                      );
                                      setFilterData((prev) => ({
                                        ...prev,
                                        firstContactPersonMobileNo: val,
                                      }));
                                      field.onChange(val);
                                    }}
                                    maxLength={10}
                                  />
                                  {errors.firstContactPersonMobileNo && (
                                    <span className="error-text">
                                      {
                                        errors.firstContactPersonMobileNo
                                          .message
                                      }
                                    </span>
                                  )}
                                </>
                              )}
                            />
                          </div>
                        </div>
                      )}

                      {!isCust && selectedTab === "Assigned Vendor" && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <label className="dateLabel">Assigned Vendor</label>
                            <select
                              className="form-control select-dropdown"
                              value={filterData.assignedVendorCode || ""}
                              onChange={(e) => {
                                const val = e.target.value;
                                setFilterData((prev) => ({
                                  ...prev,
                                  assignedVendorCode: val,
                                }));
                                setValue("assignedVendorCode", val);
                              }}
                            >
                              <option value="">Select Vendor</option>
                              {vendorList?.map((vendor) => (
                                <option
                                  key={vendor.vendorCode}
                                  value={vendor.vendorCode}
                                >
                                  {vendor.vendorName}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <div className="buttonContainer">
                    <button
                      type="button"
                      className="btn btn-back"
                      onClick={onReset}
                    >
                      Reset
                    </button>
                  </div>
                  <div className="buttonContainer">
                    <button
                      onClick={handleSubmit(onSubmit)}
                      className="btn btn-submit"
                      disabled={loading}
                    >
                      {loading ? (
                        <CircularProgress
                          style={{ width: "20px", height: "20px" }}
                        />
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CustFilterModal;
